import * as React from 'react'
import { Box, Button, TextField, Paper, MenuItem, Typography, CircularProgress, debounce, makeStyles } from '@material-ui/core'
import { useDropzone } from 'react-dropzone'
import { cos } from '../../utils/cos'
import BraftEditor, { EditorState } from 'braft-editor'
import 'braft-editor/dist/index.css'
import { getCollection, saveCollection } from '../../utils/api'
import { useFeedback } from '../../components/Feedback'
import { useParams, useHistory } from 'react-router'

const updateDetails = debounce((success) => {
    success()
}, 1000)

const useStyles = makeStyles({
    sel: {
        zIndex: 10
    }
})

const AddCollection = () => {
    const { showToast } = useFeedback()
    const [uploadImg, setUploadImg] = React.useState(false)
    const { collectionId }: { collectionId: string } = useParams()
    const [editorState, setEditorState] = React.useState(BraftEditor.createEditorState(null))
    const [collection, setCollection] = React.useState<CourseCollection>({
        name: '',
        cover: '',
        category: '',
        price: 0,
        original_price: 0,
        intro: '',
        details: '',
        details_raw: '',
        lecturer: '',
        sort: 0,
        id: '',
        courses: [],
        create_time: 0
    })

    const { acceptedFiles, getRootProps, getInputProps } = useDropzone()

    const handleUpload = (files: File[]) => {
        if (!files || files.length < 1) {
            return;
        }
        const file = files[files.length - 1]
        const filename = Date.now() + file.name.substr(file.name.lastIndexOf('.'))
        setUploadImg(true)
        cos.sliceUploadFile({
            Bucket: 'video-1302643710', /* 必须 */
            Key: 'img/cover/' + filename,              /* 必须 */
            Body: file,
            Region: 'ap-beijing',
            onTaskReady: function (taskId: any) {                   /* 非必须 */
                console.log(taskId);
            },
            onHashProgress: function (progressData: any) {       /* 非必须 */
                console.log(JSON.stringify(progressData));
            },
            onProgress: function (progressData: any) {           /* 非必须 */
                console.log(JSON.stringify(progressData));
            }
        }, (err: any, data: any) => {
            console.log(err || data);
            setUploadImg(false)
            if (!err) {
                setCollection({ ...collection, cover: `https://res.add-coach.com/${data.Key}` })
            } else {
                showToast('封面图上传失败，请重试')
            }
        })
    }



    React.useEffect(() => {
        handleUpload(acceptedFiles)
    }, [acceptedFiles])

    React.useEffect(() => {
        if (collectionId) {
            loadData(collectionId)
        }
    }, [])
    const loadData = (id: string) => {
        getCollection(id).then(res => {
            setCollection(res.data)
            if (res.data.details_raw) {
                setEditorState(BraftEditor.createEditorState(res.data.details_raw))
            } else if (res.data.details) {
                setEditorState(BraftEditor.createEditorState(res.data.details))
            }
        })
    }

    const hanldeEditorChange = (state: EditorState) => {
        updateDetails(() => {
            setCollection({ ...collection, details: state.toHTML() })
        })
        setEditorState(state)
    }

    const handleEditorUpload = (param: {
        file: File, success: (res: {
            url: string, meta: {
                id: string
                title: string
                alt: string
                loop: boolean
                autoPlay: boolean
                controls: boolean
                poster: string
            }
        }) => void
    }) => {
        const file = param.file
        const filename = Date.now() + file.name.substr(file.name.lastIndexOf('.'))

        cos.sliceUploadFile({
            Bucket: 'video-1302643710', /* 必须 */
            Key: 'img/collection/' + filename,              /* 必须 */
            Body: file,
            Region: 'ap-beijing',
            onTaskReady: function (taskId: any) {                   /* 非必须 */
                console.log(taskId);
            },
            onHashProgress: function (progressData: any) {       /* 非必须 */
                console.log(JSON.stringify(progressData));
            },
            onProgress: function (progressData: any) {           /* 非必须 */
                console.log(JSON.stringify(progressData));
            }
        }, (err: any, data: any) => {
            if (!err) {
                const url = 'https://res.add-coach.com/' + data.Key
                param.success({
                    url: url, meta: {
                        id: '',
                        title: '',
                        controls: false,
                        autoPlay: false,
                        loop: false,
                        alt: '',
                        poster: ''
                    }
                })
            }
            console.log(err || data);
        })
    }

    const handleCourseChange = (key: string) => (event: React.ChangeEvent<HTMLInputElement>, checked?: boolean) => {
        setCollection({ ...collection, [key]: event.target.value })
    }


    const handleSave = () => {
        if (!collection.name) {
            showToast('请输入课程名称')
            return;
        }
        if (!collection.cover) {
            showToast('请上传课程封面图')
            return;
        }
        if (!collection.category) {
            showToast('请选择课程分类')
            return;
        }
        if (!collection.price) {
            showToast('请输入课程定价')
            return;
        }
        collection.details = editorState.toHTML();
        collection.details_raw = editorState.toRAW();
        saveCollection(collection).then(res => {
            const { id } = res.data
            console.error(id)
            setCollection({ ...collection, id })

            showToast('提交成功')

        }).catch(e => {
            showToast('保存失败')
        })
    }


    return <Box>
        <Paper>
            <Box display="flex">
                <Box flexGrow="1" p={2}>
                    <Box display="flex" justifyContent="space-between">
                        <Button onClick={handleSave}>提交</Button>
                        <Box></Box>
                    </Box>
                    <Box mt={2}>
                        <TextField style={{ width: '240px' }} variant="outlined" size="small" label="合辑名称" value={collection.name} onChange={handleCourseChange('name')} />
                        <TextField style={{ width: '240px', marginLeft: '16px' }} variant="outlined" size="small" label="讲师" value={collection.lecturer} onChange={handleCourseChange('lecturer')} />

                    </Box>
                    <Box mt={2} display="flex">
                        <Box>
                            <Typography>合辑封面</Typography>
                            <Box width="125px" height="93px" mt={1} position="relative">
                                <div {...getRootProps({ className: 'dropzone' })} style={{ minHeight: '93px', border: '1px dashed #e1e1e1', borderRadius: '4px' }}>
                                    <input {...getInputProps()} />
                                    <Typography variant="caption" align="center">点击或拖拽封面图至此</Typography>
                                </div>
                                {collection.cover && <img src={collection.cover} style={{ position: 'absolute', top: '0', left: '0', pointerEvents: 'none', cursor: 'pointer', width: '100%', height: '100%' }} />}
                                {uploadImg && <Box display="flex" alignItems="center" justifyContent="center" style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}>
                                    <CircularProgress size={24} />
                                </Box>}
                            </Box>
                        </Box>

                    </Box>
                    <Box mt={3}>
                        <TextField value={collection.category ? `${collection.category}` : ''} onChange={handleCourseChange('category')} variant="outlined" size="small" label="合辑分类" select style={{ width: '160px' }}>
                            <MenuItem value="2">直播回看</MenuItem>
                            <MenuItem value="1">精品课</MenuItem>
                            <MenuItem value="3">大师课</MenuItem>
                        </TextField>
                        <TextField value={collection.price} onChange={handleCourseChange('price')} style={{ marginLeft: '16px' }} label="合辑价格" variant="outlined" size="small" />
                        <TextField value={collection.original_price} onChange={handleCourseChange('original_price')} style={{ marginLeft: '16px' }} label="合辑原价" variant="outlined" size="small" />
                    </Box>
                    <Box mt={2}>
                        <TextField value={collection.intro} onChange={handleCourseChange('intro')} style={{ width: '240px' }} label="合辑简介" rows={3} multiline rowsMax={3} variant="outlined" />
                    </Box>
                    <Box mt={2}>
                        <Typography>合辑详情</Typography>
                    </Box>
                    <Box border="1px solid #e1e1e1" borderRadius={4} mt={1}>
                        <BraftEditor media={{ uploadFn: handleEditorUpload }} value={editorState} onChange={hanldeEditorChange} />
                    </Box>
                </Box>
                <Box flexShrink="0">
                    {/* <CoursePreview course={course} /> */}
                </Box>
            </Box>
        </Paper>


    </Box>
}

export default AddCollection